<template>
  <v-card :elevation="0">
    <v-toolbar class="toolbar-p-0" :elevation="0" dense style="padding: 0" v-if="!hideHeader">
      <div class="text-primary-700" style="font-weight: 700; display: grid;" >
          <span style="font-size: large">Comments</span>  
          <span style="margin-top:-5px">
          <a href="https://rp-database.com/docs/features/comments-tagging-mentions" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
          </span>
      </div>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click="createNewComment = !createNewComment">
        <v-icon v-if="!createNewComment">mdi-plus</v-icon>
        <v-icon v-else>mdi-minus</v-icon>
      </v-btn> -->
      <!-- need help? button -->
    </v-toolbar>
    <!-- <v-textarea
	v-model="comments"
	label="Comments"
	outlined
	dense
	>

	</v-textarea> -->
    <div style=" height: 0">
      <div
        class="comments-dialog" :style="{ top: (selectionPosition.y + 20 ) + 'px', left: (selectionPosition.x - mentionBoundsCorrection) + 'px' }"
        v-if="searchResults.length > 0 && editingComment == 0 && selectionPosition.x != 0 && selectionPosition.y != 0"
      >
        <div
          class="comments-dialog-result"
          v-for="result, index in searchResults"
          @click="mentionUser(result)"
          :class="{ 'comments-dialog-result-focus': focus == index }"
          @mouseover="focus = index"
        >
          {{ result.name }} -
          <span style="text-transform: capitalize">{{
            result.entity_type
          }}</span>
        </div>
      </div>
    </div>
    <div v-if="createNewComment" class="comments-container mt-0">
      <!-- dialog at the top of the container displaying a list of users -->
      <div
        class="comments-placeholder"
        v-if="!commentHasContent">
        <span>Write a comment...</span>
      </div>
      <div
        id="commentInput"
        contentEditable="true"
        v-html="commentsContent"
        @focusout="commentsContent = $event.target.innerHTML"
        @keydown="keynav"
        @input="commentInput($event)"
        class="comments-area"
      ></div>
      <!-- send icon  -->
       <v-btn depressed :disabled="!commentHasContent" color="primary" class="comment-send-icon px-2" @click="saveComment(editedItem.id)">
        <span class="mr-1">Save</span>
        <v-icon small>mdi-content-save</v-icon>
       </v-btn>
      
      <span class="comments-label">Add Comment</span>
    </div>
    <!-- <v-divider v-if="createNewComment" class="mb-2 mt-6"></v-divider> -->
    <div style="position: relative; height: 0">
      <div
        class="comments-dialog"
        v-if="searchResults.length > 0 && editingComment"
      >
        <div
          class="comments-dialog-result"
          v-for="result, index in searchResults"
          @click="mentionUser(result)"
          :class="{ 'comments-dialog-result-focus': focus == index }"
          @mouseover="focus = index"
        >
          {{ result.name }} -
          <span style="text-transform: capitalize">{{
            result.entity_type
          }}</span>
        </div>
      </div>
    </div>
    <v-list
      style="overflow-y: auto;"
      class="comments-list pa-0"
    >
      <!-- <div v-if="loader" style="padding: 0; width: 1px; height: 1px"></div> -->
      <div v-if="loading" class="my-2 px-4">
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-divider class="mt-2 mb-2"></v-divider>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-divider class="mt-2 mb-2"></v-divider>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </div>

      <div v-else-if="comments.length != 0">
        <template v-for="comment in comments" >
          <v-list-item
            :key="comment.id"
            class="px-4 pt-4"
          >
            <div style="position: relative; width: 100%">
              <v-list-item-title>{{ comment.user.data.name }}</v-list-item-title>
              <v-list-item-subtitle>{{
                comment.created_at
              }}</v-list-item-subtitle>
              <!-- <div style="position: relative; height: 0">
                <div
                  class="comments-dialog"
                  v-if="searchResults.length > 0 && editingComment"
                >
                  <div
                    class="comments-dialog-result"
                    v-for="result in searchResults"
                    @click="mentionUser(result)"
                  >
                    {{ result.name }} -
                    <span style="text-transform: capitalize">{{
                      result.entity_type
                    }}</span>
                  </div>
                </div>
              </div> -->
              <div
                @focusout="editingValue = $event.target.innerHTML"
                @keydown="keynav"
                @input="commentInput($event)"
                :contenteditable="true"
                v-html="editingValue"
                class="edit-comment-area mb-4"
                v-if="editingComment == comment.id"
              ></div>
              <v-list-item-content
                class="comment-list-item"
                :contenteditable="false"
                @click="handleCommentClick(comment.id, $event)"
                v-html="comment.content"
                v-else
              ></v-list-item-content>
              <!-- edit icon position absolute at the top right -->
              <div class="comment-icon-container">
                <div v-if="editingComment == comment.id">
                  <!-- icon buttons for saving (tick) and not saving (cross) changes -->
                  <v-icon
                    @click="updateComment(comment.id)"
                    small
                    class="mr-2 comment-edit-icon"
                    >mdi-check</v-icon
                  >
                  <v-icon
                    @click="editingComment = 0; editingValue = ''; mentionedUsers = []"
                    small
                    class="comment-edit-icon"
                    >mdi-close</v-icon
                  >
                </div>
                <div v-else>
                  <v-icon
                    @click="editComment(comment)"
                    small
                    class="mr-2 comment-edit-icon"
                    >mdi-pencil</v-icon
                  >
                  <v-icon
                    @click="deleteComment(comment.id)"
                    small
                    class="comment-edit-icon"
                    >mdi-delete</v-icon
                  >
                </div>
              </div>
            </div>
          </v-list-item>
          <v-divider v-if="comments.indexOf(comment) != comments.length - 1"></v-divider>
        </template>
      </div>

      <v-list-item v-else>
        <v-list-item-title class="comments-empty py-16">
          <v-icon style="font-size: 50px">mdi-comment-off-outline</v-icon>
          <br />
          <br />
          <span style="font-size: large"
            >No comments yet, be the first to comment</span
          >
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import { set } from "lodash";
import { create } from "lodash";

export default {
  data() {
    return {
      comments: [],
      loader: true,
      loading: true,

      focus: null,

      selectionPosition: {
        x: 0,
        y: 0,
      },

      createNewComment: true,
      commentsContent: "",
      commentHasContent: false,
      editingValue: "",
      editedComment: {},
      searchResults: [],
      editingComment: 0,
      mentionedUsers: [],
      editedItem: {},
    };
  },
  props: ["entityId", "entityType", "hideHeader"],
  methods: {
    refresh() {
      this.$emit("updated");
      this.fetchComments();
    },

    keynav(e) {
      
      if (this.searchResults.length == 0){
        setTimeout(() => {
          this.checkContent(e.target.innerText);
        }, 1);
          return;
      }
      switch (e.key){
        case "ArrowUp":
          //up arrow
          
          e.preventDefault();
          if (this.focus === null) {
            this.focus = 0;
          } else if (this.focus > 0) {
            this.focus--;
          }
          break;
        case "ArrowDown":
          //down arrow
          e.preventDefault();
          if (this.focus === null) {
            this.focus = 0;
          } else if (this.focus < this.searchResults.length - 1) {
            this.focus++;
          }
          break;
        case "Enter":
          //enter key
          e.preventDefault();
          if (this.focus !== null) {
            let target = this.searchResults[this.focus];
            this.focus = null;
            if (this.editingComment == 0) {
              this.commentsContent = e.target.innerHTML;
            } else {
              this.editingValue = e.target.innerHTML;
            }
            
            this.mentionUser(target);
          }
          break;
      }
    },

    checkContent(content){
      if(content.trim() == ""){
        this.commentHasContent = false;
      }else{
        this.commentHasContent = true;
      }
      this.$emit("contentStatus", this.commentHasContent);
    },


    async fetchComments() {
      this.loader = true;
      if (
        this.entityId == undefined ||
        this.entityType == undefined ||
        this.entityId == "" ||
        this.entityType == "" ||
        this.entityId == null ||
        this.entityType == null
      ) {
        setTimeout(() => {
          this.loading = false;
        }, 150);
        this.loader = false;
        return;
      }
      await this.$http
        .get(`/comments?include=user,entity,links`, {
          params: {
            entity_id: this.entityId,
            entity_type: this.entityType,
          },
        })
        .then((response) => {
          this.comments = response.data.data;
          // get an array of each line of text in the comments that is not wrapped in a span tag, then wrap it in a p tag
          this.comments.forEach((comment) => {
     
          }); 
          
          // delay
          setTimeout(() => {
            this.loading = false;
          }, 150);
          this.loader = false;
        })
        .catch((error) => {
          setTimeout(() => {
            this.loading = false;
          }, 150);
          this.loader = false;
        });
    },

    async deleteComment(id) {
      this.$notify.question(
        `Are you sure you want to delete this comment?`,
        () => {
          this.$http.delete(`/comments/${id}`).then((response) => {
            this.refresh();
            this.fetchComments(this.editedItem.id);
          });
        }
      );
    },

    async updateComment(id) {
      for (let i = 0; i < this.mentionedUsers.length; i++) {
        let mentionedUser = this.mentionedUsers[i];
        if (!this.commentsContent.includes(mentionedUser.entity_id)) {
          this.mentionedUsers.splice(i, 1);
        } else {
          this.mentionedUsers[i] = {
            entity_id: mentionedUser.entity_id,
            entity_type: mentionedUser.entity_type,
            name: mentionedUser.name,
          };
        }
      }
      await this.$http
        .put(`/comments/${id}`, {
          content: this.editingValue,
          links: this.mentionedUsers,
        })
        .then((response) => {
          this.editingValue = "";
          this.mentionedUsers = [];
          this.editingComment = 0;
          this.fetchComments(this.editedItem.id);
        });
    },

    async saveComment() {
      // remove all mentioned users that dont exist in the comments by looking for and comparing the id of all mentioned users
      for (let i = 0; i < this.mentionedUsers.length; i++) {
        let mentionedUser = this.mentionedUsers[i];
        if (!this.commentsContent.includes(mentionedUser.entity_id)) {
          this.mentionedUsers.splice(i, 1);
        } else {
          this.mentionedUsers[i] = {
            entity_id: mentionedUser.entity_id,
            entity_type: mentionedUser.entity_type,
            name: mentionedUser.name,
          };
        }
      }
      await this.$http
        .post("/comments", {
          content: this.formatComment(this.commentsContent),
          entity_id: this.entityId,
          entity_type: this.entityType,
          links: this.mentionedUsers,
        })
        .then((response) => {
          this.refresh();
          this.commentsContent = "";
          this.commentHasContent = false;
          this.$emit("contentStatus", this.commentHasContent);
          this.mentionedUsers = [];
        })
        .catch((error) => {
          console.log(error);
        });
    },


    commentInput(e) {
      // look for the last letter entered by the user, if it is an @ symbol, start searching for the entity from there
      let lastLetter = e.data;
      this.selectionPosition = window.getSelection().getRangeAt(0).getBoundingClientRect();

      if (lastLetter == "@") {
        this.searchInput = "@";
        this.taggingUser = true;
      } else if (this.taggingUser) {
        if (e.inputType == "deleteContentBackward") {
          if (this.searchInput == "@") {
            this.taggingUser = false;
            this.searchResults = [];
          } else {
            this.searchInput = this.searchInput.slice(0, -1);
            // if the last letter of search input is @, or if searchInput.slice(1) is empty, do not search for entity
            if (this.searchInput == "@" || this.searchInput.slice(1) == " ") {
            } else {
              this.searchEntity(this.searchInput.slice(1));
            }
          }
        } else if (e.data == " " && this.searchResults.length == 0) {
          this.taggingUser = false;
          this.searchResults = [];
        } else {
          this.searchInput += lastLetter;
          if (this.searchInput.slice(1) != " ") {
            this.searchEntity(this.searchInput.slice(1));
          }
        }
      }
    },

    async searchEntity(entity) {
      // get request at /comments/search-entity?q=entity
      this.focus = null;
      await this.$http
        .get(`/comments/search-entity`, {
          params: {
            q: entity,
          },
        })
        .then((response) => {
          // if response.data is not already an array, put the data in an array
          if (!Array.isArray(response.data)) {
            response.data = [response.data];
          }
          this.searchResults = response.data;
          this.searchDialog = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    mentionUser(target) {
      target = {
        entity_id: target.entity_id,
        entity_type: target.entity_type,
        name: target.name,
      };
      this.mentionedUsers.push(target);
      let newComment = "";
      // generate random 5 digit number to use as a unique id for the span tag
      let commentID = Math.floor(Math.random() * 90000) + 10000;
      if(this.commentsContent == "") {
        newComment = `<span id="${commentID}" contenteditable="false"><span id="${target.entity_id}" class="mentioned-user" style="margin-left:0" contenteditable="false">@${target.name}</span></span>&nbsp;`;
      }else{
        newComment = `<span id="${commentID}" contenteditable="false"><span id="${target.entity_id}" class="mentioned-user" contenteditable="false">@${target.name}</span></span>&nbsp;`;
      }
      // replace the search entity inside commentsContent with the selected entity
      if (this.editingComment == 0) {
        this.commentsContent = this.commentsContent.replace(
          this.searchInput,
          newComment
        );
      } else {
        this.editingValue = this.editingValue.replace(
          this.searchInput,
          newComment
        );
      }
      this.searchResults = [];
      this.taggingUser = false;
      this.searchInput = "";

      if (this.editingComment == 0) {
        let el = document.getElementById("commentInput");
        this.moveCursor(commentID, el);
      }else {
        let el = document.querySelector(".edit-comment-area");
        this.moveCursor(commentID, el);
      }

    },

    moveCursor(entity_id, el){
      setTimeout(() => {
        // let el = document.getElementById("commentInput");
        // el.focus();
        // let range = document.createRange();
        // let lastChild = el.lastChild || el;

        // if (lastChild.nodeType === Node.TEXT_NODE) {
        //   range.setStart(lastChild, lastChild.textContent.length);
        // } else {
        //   range.setStart(lastChild, lastChild.childNodes.length);
        // }
        // range.collapse(true);

        // let sel = window.getSelection();
        // sel.removeAllRanges();
        // sel.addRange(range);

        // find the span tag with the entity id and set the cursor to the end of the span tag
        el.focus();
        let target = el.querySelector(`span[id="${entity_id}"]`);
        if (!target) return;
        let range = document.createRange();
        range.setStartAfter(target);
        range.collapse(true);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        // move right by 1 character
        sel = window.getSelection();
        range = sel.getRangeAt(0);
        range.setStart(range.startContainer, range.startOffset + 1);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);

      }, 5);
    },

    formatComment(comment){
      //add a space before every <span> using the code for space
      comment = comment.replace(/ <span/g, "&nbsp;<span");
      
      return comment;
    },

    handleCommentClick(index, e) {
      //if the user clicks on a mentioned user tag, take the entity id of that user, get the entity type and link to the entity
      if (e.target.classList.contains("mentioned-user")) {
        let entityId = e.target.id;
        let entityType = this.comments[0].links.data.find(
          (comment) => comment.entity_id == entityId
        ).entity_type;
        let entityData = { entity_id: entityId, entity_type: entityType };
        this.linkTo(entityData);
      }
    },

    linkTo(comment) {
      let routeData = {};
      if (comment.entity_type == "company") {
        routeData = this.$router.resolve({
          name: "companies",
          query: { id: comment.entity_id },
        });
      } else if (comment.entity_type == "scheme") {
        routeData = this.$router.resolve({
          name: "schemes",
          query: { id: comment.entity_id },
        });
      } else if (comment.entity_type == "property") {
        routeData = this.$router.resolve({
          name: "properties",
          query: { id: comment.entity_id },
        });
      } else if (comment.entity_type == "enquiry") {
        routeData = this.$router.resolve({
          name: "",
          query: { id: comment.entity_id, type: comment.entity_type },
        });
      } else if (comment.entity_type == "user") {
        routeData = this.$router.resolve({
          name: "users",
          query: { id: comment.entity_id },
        });
      }

      window.open(routeData.href, "_blank");
    },

    editComment(comment) {
      this.editedComment = comment;
      this.editingValue = comment.content;
      this.editingComment = comment.id;
      this.mentionedUsers = comment.links.data;
    },

    clearData() {
      this.comments = [];
      this.loader = true;
      this.createNewComment = false;
      this.commentsContent = "";
      this.editingValue = "";
      this.editedComment = {};
      this.searchResults = [];
      this.editingComment = 0;
      this.mentionedUsers = [];
      this.editedItem = {};
    },
  },
  watch: {
    entityId() {
      this.loading = true;
      this.fetchComments();
    },
  },

  computed:{
    mentionBoundsCorrection(){
      // get window size, if selection position.x is close enough to the right edge of the window, return the value needed to move the dialog to the left
      let windowWidth = window.innerWidth;
      let dialogWidth = 550;
      let correction = 0;
      if (this.selectionPosition.x + dialogWidth > windowWidth) {
        correction = dialogWidth - (windowWidth - this.selectionPosition.x);
      }
      return correction;
    }
  },
  mounted() {
    this.fetchComments();
    // get comment input element by id and disable autocomplete, spellcheck etc
    let el = document.getElementById("commentInput");
    el.spellcheck = false;
    el.autocomplete = "off";
  },
};
</script>
<style>
/* slide transition */
/* .slide-enter-active, .slide-leave-active {
  transition: transform 0.3s;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
} */
</style>
